const api = require("../api")
import AuthenticationStore from "../stores/AuthenticationStore"
import dispatcher from "../dispatcher"

export function getTopLevelDevices(hierarchyItemId, page, limit, search, cb = null) {
    const accountId = AuthenticationStore.getCookieAccountId()
    api.getTopLevelDevices(accountId, hierarchyItemId, page / limit, limit, search).then(function(response) {
        const payload = {
            totalDocumentCount: response.data.TotalDocumentCount,
            documents: response.data.Documents,
            page,
            limit,
            search
        }
        dispatcher.dispatch({
            type: "GET_TOPLEVEL_DEVICES",
            data: payload
        })
        if (cb && typeof cb === "function") {
            cb()
        }
    })
}

export function setFilterText(filterText = "") {
    dispatcher.dispatch({
        type: "UPDATE_TOPLEVEL_DEVICES_FILTER_TEXT",
        data: filterText
    })
}

export function addDevice(device) {
    return api.addDevice(device)
}

export function updateDevice(device) {
    return api.patchDevice(device)
}

export function removeDevice(deviceId) {
    return api.removeDevice(deviceId).then(function(response) {
        return response.data
    })
}
